module.exports = __webpack_public_path__ + "img/news2.2a353fef.png";